import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useState } from 'react';
import { images } from '../../../../Constants/ImageUrls';
import { removeDefaultParams } from '../../../../Utils/helper';
import { ProductNewPriceDetail } from '../../../StoreCategoryPage/SubCategoryProducts/styled';
import { Rating } from '../../../StoreHomePage/ProductCard/styled';
import { fireClickedCardEvent, productStaticData } from '../../staticData';
import { ProductCardCover, ProductImageContainer, ProductText } from './styled';

function ProductCarouselInner(props) {
  const { element, index } = props;
  const router = useRouter();
  const [clickEffect, setClickEffect] = useState();
  const productOnClick = () => {
    fireClickedCardEvent(
      'PRODUCTS YOU MAY LIKE',
      element?.name,
      element?.web_url,
    );
    setClickEffect('lowOpacity');
    setTimeout(() => {
      setClickEffect('');
    }, 200);
  };
  const ratingString = element?.starRatingSubScript;
  const ratingCountString = `(${element?.ratingCount} Ratings)`;
  const ratingText =
    (ratingString?.slice(0, ratingString.length - 1) || element?.ratingCount) +
    ' Ratings)';
  return (
    <Link
      href={{
        pathname: element?.web_url,
        query: removeDefaultParams(router.query),
      }}
      locale={false}
      passHref
      legacyBehavior
    >
      <ProductCardCover as="a" onClick={productOnClick} className={clickEffect}>
        <div
          id={
            index === 0
              ? `0first`
              : index === productStaticData?.length - 1
                ? `${productStaticData?.length - 1}last`
                : index
          }
        >
          <ProductImageContainer>
            <Image
              src={element?.image}
              quality={90}
              alt=""
              loading="lazy"
              fill
              sizes="100vw"
            />
          </ProductImageContainer>
          <ProductText>
            <p className="productName">{element?.name}</p>
            <p className="variant">
              {element?.variantType?.length ? `(${element?.variantType})` : ''}
            </p>
            <ProductNewPriceDetail search={true}>
              <span className="mainPrice">{element?.price}</span>

              <span className="strikePrice">{element?.strikePrice}</span>
              <span className="discount">{element?.discount}</span>
            </ProductNewPriceDetail>

            {element?.starRating > 0 && (
              <Rating ovulation>
                <span>{element?.starRating}</span>
                <img
                  src={images.filledStar}
                  alt="filledStar"
                  title="filledStar"
                />
                <span className="total_ratingnumber">
                  {ratingString ? ratingText : ratingCountString}
                </span>
              </Rating>
            )}
          </ProductText>
        </div>
      </ProductCardCover>
    </Link>
  );
}

export default ProductCarouselInner;
